import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING } from "./constants";
import { Backdrop, glow } from "./shared";

const QUERY = "How is batch analysis implemented in our codebase?";

export const Scene1Query: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  const fade = interpolate(frame, [durationInFrames - 20, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const boxSp = spring({ frame, fps, config: SPRING.gentle });
  const boxOp = interpolate(boxSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const boxScale = interpolate(boxSp, [0, 1], [0.8, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const chars = Math.floor(interpolate(frame, [40, 220], [0, QUERY.length], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  }));

  return (
    <AbsoluteFill style={{ background: COLORS.bg, opacity: fade, overflow: "hidden" }}>
      <Backdrop frame={frame} accent={COLORS.neonCyan} />

      {/* Label */}
      <div style={{
        position: "absolute", top: 340, left: 0, right: 0,
        textAlign: "center",
        opacity: boxOp,
      }}>
        <div style={{
          fontSize: 22,
          fontFamily: FONTS.mono,
          color: COLORS.neonCyan,
          letterSpacing: 4,
          textTransform: "uppercase",
          textShadow: glow(COLORS.neonCyan),
          fontWeight: 700,
        }}>
          You ask EAKC a hard question
        </div>
      </div>

      {/* Big 3D query terminal */}
      <div style={{
        position: "absolute",
        top: 430,
        left: "50%",
        transform: `translateX(-50%) scale(${boxScale}) perspective(1600px) rotateX(6deg)`,
        width: 1500,
        opacity: boxOp,
      }}>
        <div style={{
          background: `linear-gradient(135deg, ${COLORS.bgCardLight}, ${COLORS.bgCard})`,
          border: `3px solid ${COLORS.neonCyan}`,
          borderRadius: 24,
          padding: "42px 56px",
          boxShadow: `0 0 60px ${COLORS.neonCyan}55, 0 0 120px ${COLORS.neonCyan}22, 0 30px 60px rgba(0,0,0,0.6)`,
          position: "relative",
        }}>
          {/* Traffic lights */}
          <div style={{ display: "flex", gap: 10, marginBottom: 28 }}>
            {[COLORS.neonRed, COLORS.neonYellow, COLORS.neonGreen].map((c, i) => (
              <div key={i} style={{
                width: 16, height: 16, borderRadius: "50%",
                background: c, boxShadow: `0 0 12px ${c}`,
              }} />
            ))}
          </div>
          {/* Query */}
          <div style={{
            fontSize: 46,
            fontFamily: FONTS.mono,
            color: COLORS.textPrimary,
            lineHeight: 1.4,
            display: "flex",
            alignItems: "flex-start",
            gap: 18,
          }}>
            <span style={{
              color: COLORS.neonCyan,
              fontWeight: 900,
              textShadow: glow(COLORS.neonCyan),
            }}>❯</span>
            <span>
              {QUERY.slice(0, chars)}
              {chars < QUERY.length && (
                <span style={{
                  display: "inline-block",
                  width: 4,
                  height: 48,
                  background: COLORS.neonCyan,
                  marginLeft: 4,
                  verticalAlign: "middle",
                  opacity: Math.sin(frame * 0.3) > 0 ? 1 : 0,
                  boxShadow: `0 0 10px ${COLORS.neonCyan}`,
                }} />
              )}
            </span>
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
